<template>
  <div class="filetree-wrapper">
    <div v-if="isLoading">
      <spinner size="small" message="Loading..."></spinner>
    </div>
    <li v-else v-for="(value,index) in localModel" :key="index">
      <div v-if="value.type=='d'">
        <a class="file-cont" @click="toggleOpen(value,index,$event)">
          <span class="px-1">
            <down-icon v-show="value.type=='d'" class="icon-default down-icon" v-bind:class="{invert:value.isOpen}"></down-icon>
          </span>
          <span class="px-1">
            <folder-icon class="icon-default folder-icon"></folder-icon>
          </span>
          <span class="file-name">
            {{ value.name }}
          </span>
          <b-btn class="file-select-btn" v-show="value.type=='d'" @click="selectFolder(value,$event)">
            select
          </b-btn>
        </a>
      </div>
      <ul v-if="value.children && value.isOpen" class="child-cont">
        <file-tree :model="value.children" :ftpDetails="ftpDetails" @onSelect="onSelect" @onError="onError" @onSuccess="onSuccess">
        </file-tree>
      </ul>
    </li>

  </div>

</template>

<script>
import DownIcon from '../../assets/down.svg';
import FolderIcon from '../../assets/folder.svg';
import Vue from 'vue';
import axios from 'axios';
import param from 'jquery-param';
export default {
  name: 'FileTree',
  components: {
    DownIcon,
    FolderIcon,
    'file-tree': () => import('./FileTree')
  },
  props: {
    model: Array,
    ftpDetails: Object,
    init: Boolean
  },
  mounted() {
    if (this.model) {
      this.localModel = _.cloneDeep(this.model);
    }
    if (this.init) {
      this.isLoading = true;
      this.loadFiles(this.ftpDetails.remoteFolder)
        .then(files => {
          if (files && typeof files == 'object') {
            this.localModel = files;
            this.isLoading = false;
          } else {
            this.$emit('onError', {});
          }
        })
        .catch(err => {
          this.$emit('onError', err);
        });
    }
  },
  data: () => {
    return {
      serverURL: window.serverURL,
      localModel: [],
      open: false,
      isLoading: false
    };
  },
  computed: {},
  methods: {
    toggle: function() {
      if (this.isFolder) {
        this.open = !this.open;
      }
    },
    toggleOpen(item, index, $event) {
      $event.preventDefault();
      $event.stopPropagation();
      if (item.type == 'd') {
        item.isOpen = !item.isOpen;
        if (item.isOpen) {
          this.loadFiles(item.path + item.name + '/')
            .then(files => {
              this.localModel[index].children = files;
              Vue.set(this.localModel, index, item);
            })
            .catch(err => {
              this.$emit('onError', err);
            });
        } else {
          Vue.set(this.localModel, index, item);
        }
      }
    },
    selectFolder(value, $event) {
      $event.stopPropagation();
      $event.preventDefault();
      this.$emit('onSelect', value);
    },
    onSelect(event) {
      this.$emit('onSelect', event);
    },
    onError(event) {
      this.$emit('onError', event);
    },
    onSuccess(event) {
      this.$emit('onSuccess', event);
    },
    loadFiles(dir) {
      let URL = `${serverURL}lib/JqueryfileTree/connectors/jqueryFileTree.php`;
      let useSftp = 0;
      let hostSSL = 0;
      if (this.ftpDetails.use_sftp === '1') {
        useSftp = 1;
        hostSSL = 0;
      } else if (this.ftpDetails.use_ftpssl === '1') {
        useSftp = 0;
        hostSSL = 1;
      }
      let payload = {
        dir: dir,
        hostName: this.ftpDetails.hostName,
        hostPort: this.ftpDetails.hostPort,
        hostUserName: this.ftpDetails.hostUserName,
        hostPassword: this.ftpDetails.hostPassword,
        useSftp: useSftp,
        hostSSL: hostSSL,
        hostPassive: this.ftpDetails.hostPassive,
        V3: 1
      };
      return axios
        .post(URL, param(payload), {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          withCredentials: true
        })
        .then(response => {
          if (response.data.success) {
            return Promise.resolve(_.sortBy(response.data.success, 'type'));
          }

          return Promise.reject(null);
        })
        .catch(err => {
          return Promise.reject(null);
        });
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Common/FileTree.vue